<template>
  <div>
    <el-button
      v-if="this.activeName == '1'"
      class="button"
      type="primary"
      @click="add()"
      >新增</el-button
    >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="分类管理" name="1">
        <!-- 标题 -->
        <div class="title">
          <div>本草分类管理</div>
          <div>
            <el-button
              type="primary"
              style="margin-top: 20px;"
              @click="editSort()"
              >排序管理</el-button
            >
            <el-button
              v-show="isSortShow"
              type="primary"
              style="margin-top: 20px;"
              @click="saveSortData()"
              >保存排序</el-button
            >
          </div>
        </div>
        <el-table
          :data="classMeridiansData"
          class="table"
          v-show="isSortShow"
          v-loading="loading"
          ref="multipleTable"
          row-key="id"
          border
        >
          <el-table-column prop="title" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-edit"
                @click="handleSon(scope.row)"
                >添加子分类</el-button
              >
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 2)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 2)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="classMeridiansData"
          v-show="!isSortShow"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          row-key="id"
          :tree-props="{ children: 'sub_items' }"
          border
        >
          <el-table-column prop="title" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-edit"
                @click="handleSon(scope.row)"
                >添加子分类</el-button
              >
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 2)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.parent_id == 0"
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 2)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="本草管理" name="2">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="穴名：">
              <el-input v-model="formInline.title"></el-input>
            </el-form-item>
            <el-form-item label="类别">
              <el-cascader
                :props="categoryProps"
                @change="changeCategories"
                v-model="categoryData"
                :options="options"
              ></el-cascader>
            </el-form-item>
          </div>
        </el-form>
        <!-- 标题 -->
        <div class="title">
          <div>本草列表</div>
          <el-button type="primary" @click="search()">查询</el-button>
        </div>
        <el-table :data="bencaoData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" width="100">
          </el-table-column>
          <el-table-column prop="title" label="药名" align="center" width="150">
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="分类"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="reference" label="出处" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">详情</el-button>
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="yian_totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="yian_currentPage"
            :page-size="yian_page_size"
            :total="yian_pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 父编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="分类名称：" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 子编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible1"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form1" label-width="120px">
        <el-form-item label="分类名称：" prop="title">
          <el-input v-model="form1.title"></el-input>
        </el-form-item>

        <el-form-item label="父级分类：" prop="father_class">
          <el-select v-model="form1.father_class" class="handle-select mr10">
            <el-option
              v-for="(child, index) in father_class"
              :key="index"
              :label="child.title"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="submit()">提 交</el-button>

        <el-button type="primary" @click="editVisible1 = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 本草管理编辑弹出框 -->
    <el-dialog
      :visible.sync="editBencaoVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '2'"
    >
      <el-form ref="ruleForm" :model="bencaoForm" label-width="180px">
        <el-form-item label="经穴ID：">
          <el-input type="text" v-model="bencaoForm.id"></el-input>
        </el-form-item>
        <el-form-item label="经穴名：">
          <el-input type="text" v-model="bencaoForm.title"></el-input>
        </el-form-item>
        <el-form-item label="概述：">
          <el-input type="text" v-model="bencaoForm.introduce"></el-input>
        </el-form-item>
        <el-form-item label="药性：">
          <el-input type="text" v-model="bencaoForm.attr"></el-input>
        </el-form-item>
        <el-form-item label="功效：">
          <el-input type="text" v-model="bencaoForm.effect"></el-input>
        </el-form-item>
        <el-form-item label="临床：">
          <el-input type="text" v-model="bencaoForm.clinical"></el-input>
        </el-form-item>
        <el-form-item label="用法用量：">
          <el-input type="text" v-model="bencaoForm.usage"></el-input>
        </el-form-item>
        <el-form-item label="使用注意：">
          <el-input type="text" v-model="bencaoForm.careful"></el-input>
        </el-form-item>
        <el-form-item label="炮制：">
          <el-input type="text" v-model="bencaoForm.processing"></el-input>
        </el-form-item>
        <el-form-item label="鉴别：">
          <el-input type="text" v-model="bencaoForm.identify"></el-input>
        </el-form-item>
        <el-form-item label="各家概述：">
          <el-input type="text" v-model="bencaoForm.various"></el-input>
        </el-form-item>
        <el-form-item label="附方：">
          <el-input type="text" v-model="bencaoForm.fang"></el-input>
        </el-form-item>
        <el-form-item label="别名：">
          <el-input type="text" v-model="bencaoForm.alias"></el-input>
        </el-form-item>
        <el-form-item label="来源：">
          <el-input type="text" v-model="bencaoForm.source"></el-input>
        </el-form-item>
        <el-form-item label="附注：">
          <el-input type="text" v-model="bencaoForm.mark"></el-input>
        </el-form-item>
        <el-form-item label="出处：">
          <el-input type="text" v-model="bencaoForm.reference"></el-input>
        </el-form-item>
        <el-form-item label="类目：">
          <el-cascader
            v-model="bencaoForm.category_info"
            :options="options1"
            :props="categoryProps1"
            :show-all-levels="false"
            @change="caChange($event)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="经穴图片：">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="bencaoForm.full_img_path"
              :src="bencaoForm.full_img_path"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!bencaoForm.full_img_path && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in bencaoForm.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editBencaoVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
import md5 from "js-md5";
export default {
  data() {
    return {
      isSortShow: false,
      id: "",
      imageUrl: "",
      uploading: false,
      editVisible: false,
      editVisible1: false,
      editMeridiansVisible: false,
      editBencaoVisible: false,
      editHotVisible: false,
      classificationDataLv2Visible: false,
      is_add: true,
      parent_id: "",
      class_id: "",
      p_id: "",
      classification_type: 1,
      bencao_id: "",
      activeName: "1",
      loading: false,
      father_class: [],
      //   类别
      categoryData: [],
      options1: [],
      categoryProps1: {
        label: "title", // 字段必须统一
        value: "id", // 字段必须统一
        children: "sub_items",
      },
      category_ids: "",
      options: [],
      categoryProps: {
        label: "title", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/zsk/medicine_select", {
              params: { parent_id: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                console.log(res);
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  title: item.title,
                  leaf: level >= 1,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 1000);
            });
        },
      },
      father_add: true,
      // ----------------搜索----------------
      formInline: {},
      //   一级分类
      classMeridiansData: [],
      //   医案列表
      bencaoData: [],
      //   医案管理分页
      yian_currentPage: 1,
      yian_totalPages: 1,
      yian_page_size: 10,
      yian_pageTotal: 10,
      yian_page_index: 10,
      classForm: {},
      form: {},
      form1: {},
      bencaoForm: {},
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      dataArr: [],
      ids: [],
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/zsk/sort/medicine/categories", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    caChange(e) {
      for (let i = 0; i < e.length; i++) {
        this.category_ids = e[1];
      }
    },
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.bencaoForm.labels.push(newItem);
    },
    delBq(i) {
      this.bencaoForm.labels.splice(i, 1);
    },
    getDefault() {
      if (this.activeName == 1) {
        // 基础分类
        let parent_id = 0;
        http
          .get("/admin/zsk/medicine_select", {
            params: { parent_id: parent_id },
          })
          .then((res) => {
            if (res.data.status_code == 200) {
              this.options = res.data.data;
            }
          });
        this.loading = true;
        http.get("/admin/zsk/medicine_categorys").then((res) => {
          if (res.data.status_code == 200) {
            this.options1 = res.data.data;
            this.classMeridiansData = res.data.data;
            this.dataArr = res.data.data;
            this.$nextTick(() => {
              this.initSortTable();
            });
            this.father_class = res.data.data;
            this.loading = false;
          }
        });
      } else if (this.activeName == 2) {
        this.loading = true;
        let params = {
          page: this.yian_currentPage,
          yian_page_size: this.yian_page_size,
          title: this.formInline.title,
          categories_id: this.formInline.categories_id,
        };
        http.get("/admin/zsk/medicine_list", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.bencaoData = res.data.data.data;
            this.yian_currentPage = Number(res.data.data.current_page);
            this.yian_totalPages = res.data.data.last_page;
            this.yian_pageTotal = this.yian_totalPages * this.yian_page_size;
            this.loading = false;
          }
        });
      }
    },
    changeCategories(e) {
      var arr = e;
      this.formInline.categories_id = arr[arr.length - 1];
    },
    // 搜索
    search() {
      if (this.activeName == 2) {
        this.getDefault();
      }
    },
    // 新增
    add() {
      if (this.activeName == "1") {
        this.father_add = true;
        this.form = {};
        this.editVisible = true;
      } else if (this.activeName == "2") {
        this.bencaoForm = {};
        this.editBencaoVisible = true;
        this.is_edit = false;
        this.is_add = false;
      }
    },
    // 提交
    saveEdit() {
      if (this.activeName == "1") {
        if (this.father_add == true) {
          let params = {
            title: this.form.title,
            parent_id: 0,
          };
          http.post("/admin/zsk/medicine_category", params).then((res) => {
            if (res.data.status_code == 200) {
              this.getDefault();
              this.editVisible = false;
              this.$message.success("新增成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else if (this.father_add == false) {
          let params = {
            title: this.form.title,
            parent_id: 0,
          };
          http
            .put("/admin/zsk/medicine_category/" + this.id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.getDefault();
                this.editVisible = false;
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      } else if (this.activeName == "2") {
        if (this.is_edit == true) {
          let params = this.bencaoForm;
          if (params.full_img_path) {
            delete params.full_img_path;
          }
          params.img_path = this.imageUrl;
          // 标签处理
          let labels = this.bencaoForm.labels;
          let data = "";
          this.bencaoForm.labels = "";
          for (let i = 0; i < labels.length; i++) {
            data = labels[i].type + "_" + labels[i].title + ",";
            this.bencaoForm.labels += data;
          }
          this.bencaoForm.labels = this.bencaoForm.labels.substring(
            0,
            this.bencaoForm.labels.length - 1
          );
          this.bencaoForm.categories_id = this.category_ids;
          http
            .put("/admin/zsk/medicine/" + this.bencao_id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.editBencaoVisible = false;
                this.getDefault();
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }
    },
    // 子分类
    submit() {
      if (this.is_add == true) {
        let params = {
          title: this.form1.title,
          parent_id: this.form1.father_class,
        };
        http.post("/admin/zsk/medicine_category", params).then((res) => {
          if (res.data.status_code == 200) {
            this.getDefault();
            this.editVisible1 = false;
            this.$message.success("新增子分类成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.is_add == false) {
        let params = {
          title: this.form1.title,
          parent_id: this.form1.father_class,
        };
        http
          .put("/admin/zsk/medicine_category/" + this.id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.getDefault();
              this.editVisible1 = false;
              this.$message.success("修改子分类成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    // 添加子分类
    handleSon(row) {
      this.form1 = {};
      this.is_add = true;
      this.editVisible1 = true;
      this.form1.father_class = row.id;
    },
    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "mediawiki/acupuncture");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "mediawiki/acupuncture/" + filename;
            that.bencaoForm.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 详情
    detail(row) {
      this.is_add = true;
      this.editBencaoVisible = true;
      this.bencao_id = row.id;
      this.getDetailInfo();
    },
    getDetailInfo() {
      let params = {
        title: this.classForm.title,
      };
      http.get("/admin/zsk/medicines/" + this.bencao_id, params).then((res) => {
        if (res.data.status_code == 200) {
          this.bencaoForm = res.data.data;
          let data = res.data.data;
          // 类目
          for (let i = 0; i < data.category_info.length; i++) {
            this.category_ids = data.category_info[1];
          }
        }
      });
    },
    // 编辑
    edit(row, type) {
      if (this.activeName == "1") {
        if (type == 1) {
          this.form = {
            title: row.title,
            father_class: row.id,
          };
          this.id = row.id;
          this.father_add = false;
          this.editVisible = true;
        } else if (type == 2) {
          this.form1 = {
            title: row.title,
            father_class: row.parent_id,
          };
          this.id = row.id;
          this.is_add = false;
          this.editVisible1 = true;
        }
      } else if (this.activeName == "2") {
        this.editBencaoVisible = true;
        this.is_add = false;
        this.is_edit = true;
        this.bencao_id = row.id;
        this.getDetailInfo();
      }
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zsk/medicine_category/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选项卡
    handleClick(tab) {
      if (tab.index == 1) {
        this.getDefault();
      }
    },
    // 医案管理分页
    handlePageChange(val) {
      this.yian_currentPage = val;
      this.getDefault();
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
